import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Rajesh Kumar',
      role: 'Property Owner',
      rating: 5,
      text: 'FURNIFLEX has transformed my property management experience. They took my flat, furnished it beautifully, and now I get guaranteed rent every month. The team handles everything professionally - from tenant management to maintenance. Highly recommended!',
      property: '3 Properties',
      location: 'Sector 78, Noida'
    },
    {
      id: 2,
      name: 'Priya Sharma',
      role: 'Tenant',
      rating: 5,
      text: 'I found my perfect furnished home through FURNIFLEX! The flat was beautifully furnished and move-in ready. The best part is their quick response to any issues. Maintenance requests are resolved within hours. Living here has been a wonderful experience.',
      property: 'Tenant since April 2025',
      location: 'Sector 76, Noida'
    },
    {
      id: 3,
      name: 'Amit Patel',
      role: 'Property Owner',
      rating: 5,
      text: 'As a property owner, FURNIFLEX has been a game-changer. They furnished my flat with quality furniture and found reliable tenants quickly. The guaranteed rent program gives me peace of mind, and I don\'t have to worry about anything.',
      property: '2 Properties',
      location: 'Sector 119, Noida'
    },
    {
      id: 4,
      name: 'Anjali Mehta',
      role: 'Tenant',
      rating: 5,
      text: 'Moving to a new city was stressful, but FURNIFLEX made it so easy! They provided a fully furnished flat with all amenities. Whenever I face any issue, their support team is just a call away. Truly exceptional service!',
      property: 'Tenant since May 2025',
      location: 'Sector 76, Noida'
    },
    {
      id: 5,
      name: 'Vikram Singh',
      role: 'Property Owner',
      rating: 5,
      text: 'FURNIFLEX exceeded my expectations. They took my empty flat, furnished it tastefully, and now it generates steady rental income. The transparency in communication and financial reporting is excellent. Best decision for my property investment.',
      property: '1 Property',
      location: 'Sector 93, Noida'
    },
    {
      id: 6,
      name: 'Kavita Reddy',
      role: 'Tenant',
      rating: 5,
      text: 'I\'ve been living in a FURNIFLEX property since they started. The furnished flat is well-maintained, and any maintenance issues are resolved immediately. The team is professional, responsive, and truly cares about tenant satisfaction.',
      property: 'Tenant since April 2025',
      location: 'Sector 75, Noida'
    }
  ];

  return (
    <section className="bg-white py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-gray-400"
            >
              <path d="M17 7.828a3 3 0 0 0-4.242 0l-5.586 5.586a3 3 0 0 0 0 4.242l4.172 4.172a3 3 0 0 0 4.242 0l5.586-5.586a3 3 0 0 0 0-4.242z" />
              <path d="M7 13l3 3 7-7" />
            </svg>
            <span className="text-sm md:text-base text-gray-500 uppercase tracking-wide font-medium">
              TESTIMONIALS
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 uppercase mb-4">
            See What Our Clients Say
          </h2>
          <div className="w-16 h-0.5 bg-gray-900 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-700 max-w-2xl mx-auto">
            We let our professional management speak for itself, but also value our clients' candid experiences partnering with us
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gray-50 rounded-lg p-6 md:p-8 hover:shadow-lg transition-shadow"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg
                    key={i}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="text-yellow-400"
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="border-t border-gray-200 pt-4">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 rounded-full bg-furniflex-teal flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-2">
                  {testimonial.location && (
                    <span className="block mb-1">{testimonial.location}</span>
                  )}
                  {testimonial.role === 'Tenant' ? testimonial.property : `${testimonial.property} managed`}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

